import {create} from 'zustand';

interface NotiState {
    notificationYn: boolean;
    isLoading: boolean;

    setNotificationYn: (enabled: boolean) => void;
    setLoading: (loading: boolean) => void;
    initialize: (initialValue?: boolean) => void;
}

export const useNotiStore = create<NotiState>(set => ({
    notificationYn: false,
    isLoading: false,

    setNotificationYn: (isEnabled: boolean) => {
        set({notificationYn: isEnabled});
    },

    setLoading: (loading: boolean) => {
        set({isLoading: loading});
    },

    initialize: (initialValue?: boolean) => {
        if (initialValue !== undefined) {
            set({notificationYn: initialValue});
        }
    },
}));
